import React, { Component } from 'react';

export default class WorkspaceTopBar extends Component {

	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let outerStyle = {};

		if (!this.props.isScrollTop) {
			outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
		}

		return (
			<div className={"workspace-top-bar-outer"}>
				<div className={"workspace-top-bar-normal-container"}>
					<div className={"menu-button material-icons"} onClick={this.props.toggleNav}>menu</div>
					<div className={"selector-container"}>
						<div className={"w-text title"}>Dashboards</div>
					</div>
				</div>
			</div>
		);
	}
}
